import React from "react";
import { Button } from "semantic-ui-react";
import styles from "./index.module.css";
import ManualIncreaseControls from "./ManualIncreaseControls";
import { PickProgressActions, PickProgressData } from "../../OrderOverview/OrderOverview";

type Props = {
  disabled: boolean;
  data: PickProgressData;
  actions: Omit<PickProgressActions, "onAutoVerifyQuantity">;
};

const PickQuantityControls = ({ disabled, data, actions }: Props) => {
  const { itemId, confirmedQuantity, pickedQuantity } = data;
  const { onIncreaseAdjustedPick, onDecreaseAdjustedPick, onConfirmExcessPicks } = actions;

  // const computedPickedQuantity = useMemo(() => Math.max(adjustedPickedQuantity > pickedQuantity ? pickedQuantity, 0), [
  //   confirmedQuantity,
  //   pickedQuantity,
  // ]);

  // const onDecreaseQuantityHandler = () => {
  //   if (increasedQuantity === 0 && missingQuantity === 0) return onIncreaseMissingQuantity();
  //   if (increasedQuantity > 0) {
  //     onManuallyDecreaseQuantity();
  //   }
  //   if (missingQuantity > 0) {
  //     onIncreaseMissingQuantity();
  //   }
  // };

  // const onIncreaseQuantityHandler = () => {
  //   if (increasedQuantity === 0 && missingQuantity === 0) return onManuallyIncreaseQuantity();
  //   if (increasedQuantity > 0) {
  //     onManuallyIncreaseQuantity();
  //   }
  //   if (missingQuantity > 0) {
  //     onDecreaseMissingQuantity();
  //   }
  // };

  return (
    <div className={styles["pick-quantity-controls"]}>
      {pickedQuantity > confirmedQuantity ? (
        <Button onClick={() => onConfirmExcessPicks(itemId)}>Bekräfta</Button>
      ) : (
        <ManualIncreaseControls
          data={data}
          actions={{ onIncreaseAdjustedPick, onDecreaseAdjustedPick }}
          disabled={disabled}
        />
      )}
    </div>
  );
};

export default PickQuantityControls;
